<template>
  <div class="is">
    <div class="is-totals">
      <div class="is-total">
        <b>{{ final.totals.update }}</b> обновится
      </div>
      <div class="is-total">
        <b>{{ final.totals.create }}</b> новых
      </div>
      <div class="is-total del">
        <b>{{ checkedCount }}</b> удалится<span v-if="checkedCount !== final.totals.delete"> из {{ final.totals.delete }}</span>
      </div>
      <div class="is-total muted">
        <b>{{ final.totals.unchanged }}</b> без изменений
      </div>
      <div class="is-total muted">
        <b>{{ final.totals.skip }}</b> пропущено
      </div>
    </div>

    <v-alert
      v-if="nothingToDo"
      dense
      text
      type="info"
      class="is-alert"
    >
      Файл совпадает с текущими зонами - менять нечего.
    </v-alert>

    <v-expansion-panels
      v-else
      multiple
      accordion
      class="is-panels"
    >
      <v-expansion-panel v-for="f in groups" :key="f.filialId || 0">
        <v-expansion-panel-header>
          <div class="is-head">
            <span class="is-filial">{{ filialTitle(f) }}</span>
            <span class="is-badges">
              <span v-if="f.update.length" class="b upd">{{ f.update.length }} обн.</span>
              <span v-if="f.create.length" class="b new">+{{ f.create.length }}</span>
              <span v-if="f.delete.length" class="b del">−{{ checkedIn(f) }}</span>
              <span v-if="f.unchanged" class="b">{{ f.unchanged }} без изм.</span>
              <span v-if="f.skip.length" class="b">{{ f.skip.length }} пропуск</span>
            </span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-if="f.update.length" class="is-sec">
            <div class="is-sec-title">
              Обновится
            </div>
            <div v-for="z in f.update" :key="z.key" class="is-item">
              <span class="dot" :style="{ background: colorOf(z.color) }" />
              <span class="nm">{{ z.name }}</span>
              <span class="chg">{{ changesText(z.changes) }}</span>
            </div>
          </div>
          <div v-if="f.create.length" class="is-sec">
            <div class="is-sec-title">
              Новые зоны
            </div>
            <div v-for="z in f.create" :key="z.key" class="is-item">
              <span class="dot" :style="{ background: colorOf(z.color) }" />
              <span class="nm">{{ z.name }}</span>
              <span class="chg">{{ area(z.areaM2) }}</span>
            </div>
          </div>
          <div v-if="f.delete.length" class="is-sec">
            <div class="is-sec-title">
              Удалится (нет в файле)
            </div>
            <v-checkbox
              v-for="z in f.delete"
              :key="z.zoneId"
              :input-value="!!value[z.zoneId]"
              hide-details
              dense
              class="is-check"
              @change="toggle(z.zoneId, $event)"
            >
              <template v-slot:label>
                <span class="dot" :style="{ background: colorOf(z.color) }" />{{ z.name }}
              </template>
            </v-checkbox>
          </div>
          <div v-if="f.skip.length" class="is-sec">
            <div class="is-sec-title">
              Пропущено
            </div>
            <div v-for="z in f.skip" :key="z.key" class="is-item muted">
              <span class="nm">{{ z.name || '(без названия)' }}</span>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import { ZONE_COLORS } from '@/constants/deliveryZones'

  const CHANGE_NAMES = { name: 'имя', color: 'цвет', geometry: 'контур' }

  /**
   * Итог импорта по филиалам (ответ import/resolve). v-model - отмеченные к удалению: zoneId → true.
   */
  export default {
    name: 'ImportSummaryStep',
    props: {
      final: { type: Object, required: true },
      filials: { type: Array, default: () => [] },
      value: { type: Object, default: () => ({}) },
    },
    computed: {
      // филиалы, где что-то происходит (без «только без изменений»)
      groups () {
        return this.final.filials.filter((f) => f.update.length || f.create.length || f.delete.length || f.skip.length)
      },
      checkedCount () {
        return Object.values(this.value).filter(Boolean).length
      },
      nothingToDo () {
        const t = this.final.totals
        return !t.update && !t.create && !t.delete && !this.groups.length
      },
    },
    methods: {
      toggle (zoneId, on) {
        this.$emit('input', { ...this.value, [zoneId]: !!on })
      },
      checkedIn (group) {
        return group.delete.filter((z) => this.value[z.zoneId]).length
      },
      filialTitle (group) {
        const f = this.filials.find((x) => x.id === group.filialId)
        return f ? [f.address || f.name, f.city].filter(Boolean).join(', ') : group.name
      },
      colorOf (c) {
        return ZONE_COLORS[c] || '#ccc'
      },
      changesText (changes) {
        return (changes || []).map((c) => CHANGE_NAMES[c] || c).join(', ')
      },
      area (m2) {
        return m2 >= 100000 ? (m2 / 1e6).toFixed(1) + ' км²' : Math.round(m2).toLocaleString('ru') + ' м²'
      },
    },
  }
</script>

<style scoped>
.is-totals {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.is-total {
  background: #f1f9f0;
  color: #2e7d32;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 13px;
}
.is-total.del {
  background: #fdecea;
  color: #c62828;
}
.is-total.muted {
  background: #f1f3f6;
  color: rgba(0, 0, 0, 0.6);
}
.is-alert {
  margin-top: 16px;
  border-radius: 8px;
}
.is-panels {
  margin-top: 12px;
  max-height: 46vh;
  overflow-y: auto;
}
.is-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}
.is-filial {
  font-weight: 500;
  font-size: 14px;
}
.is-badges {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.b {
  font-size: 11px;
  border-radius: 6px;
  padding: 2px 6px;
  background: #f1f3f6;
  color: rgba(0, 0, 0, 0.6);
}
.b.upd {
  background: #fff4e5;
  color: #e65100;
}
.b.new {
  background: #f1f9f0;
  color: #2e7d32;
}
.b.del {
  background: #fdecea;
  color: #c62828;
}
.is-sec + .is-sec {
  margin-top: 10px;
}
.is-sec-title {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
  margin-bottom: 4px;
}
.is-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  padding: 2px 0;
}
.is-item.muted {
  color: rgba(0, 0, 0, 0.55);
}
.is-item .nm {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.is-item .chg {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
}
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  flex: 0 0 10px;
  margin-right: 6px;
}
.is-check {
  margin: 0;
  padding: 0;
}
.is-check ::v-deep label {
  font-size: 13px;
}
</style>
